import { ServiceType } from "./DataBrokers.model";
import { PrivacyIssueType, ActionType } from "./PrivacyIssue.model";

export enum FeedbackType {
    DATA_BROKERS = 'data_brokers',
    EARLYVANGHELIST = 'earlyvanghelist',
    BREACH = 'breach'
}

export enum FeedbackProblem {
    OTHER = 'other',
    NO_ACCOUNT = 'noAccount',
    DAMAGED_LINK = 'damagedLink',
    DATA_BROKER = 'databroker',
    DO_NOT_UNDERSTAND = 'donotunderstand'
}

export class FeedbackDialogModel {
    question: FeedbackDialogQuestionModel;
    success: FeedbackDialogSuccessModel;
}

export class FeedbackDialogQuestionModel {
    title: string;
    subtitle?: string;
    description?: string;
    inputPlaceholder: string;
    sendLabel: string;
}

export class FeedbackDialogSuccessModel {
    img: string;
    title: string;
    subtitle?: string;
    description?: string;
    closeLabel: string;
}

export class FeedbackModel {
    problem: string;
    description: string;
    type: PrivacyIssueType|ServiceType;
    actionType: ActionType;
    serviceName: string
}
